export function calculatePages(formElements, includeElementIds, forceOnePage) {
    let pageNumber = 1;
    let start = 0;
    const untitledPage = "Untitled Page";
    let page = {
        PageNumber: 1,
        FormElements: [],
        PageBreakElement: null
    };
    const pages = [];

    for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];
        if (element.ClassName === "PageBreakElement") {
            page.Title = element.Properties.pagetitle || untitledPage;
            page.Element = element;
            if (start < i && includeElementIds) {
                page.FormElements = page.FormElements.concat(
                    formElements.slice(start, i).map((formElement) => formElement.PublicId)
                ); // don't include page break element
            }
            start = i + 1;
            pageNumber++;
            if (!forceOnePage) {
                // when in admin mode we want just one page with every non page break element in there
                page.PageBreakElement = element;
                pages.push(page);
                page = {
                    PageNumber: pageNumber,
                    Title: element.Properties.lastpagetitle || untitledPage,
                    FormElements: [],
                    PageBreakElement: null
                };
            }
        }
    }
    // need to account for the last page since we don't store the last page break;
    // If the last element was a page break, that means the last page is completely empty. Dont add any elements in that case.
    if (start < formElements.length && includeElementIds) {
        page.FormElements = page.FormElements.concat(
            formElements.slice(start).map((formElement) => formElement.PublicId)
        );
    }
    pages.push(page);
    return pages;
}
